/* GiftInOne 2.15.1: one public resolver, no missing-namespace browser probes.
 * The server checks both storage formats; collisions and configuration faults
 * remain manual-order conditions and never become automatic print approval. */
(function (window) {
  'use strict';
  if (window.GIOUnifiedTemplateRouter) return;
  function error(code, message) { var value = new Error(message); value.code = code; return value; }
  function text(value) { return value == null ? '' : String(value).trim(); }
  function assignment(context) {
    var original = context.directTemplate || {}, legacy = context.directComposition || {};
    var product = original.product || {}, variant = original.variant || {};
    var productId = text(product.template) || text(legacy.product && legacy.product.composition);
    var variantId = text(variant.template) || text(legacy.variant && legacy.variant.composition);
    var normalized = Object.assign({}, context, { directTemplate: {
      product: Object.assign({}, legacy.product || {}, product, { template: productId }),
      variant: Object.assign({}, legacy.variant || {}, variant, { template: variantId })
    } });
    return { id: variantId || productId, source: variantId ? 'variant' : 'product', context: normalized };
  }
  function create() {
    var cache = Object.create(null), pending = Object.create(null);
    // Resolve both namespaces on the server. An absent optional S3 object
    // must never become a browser request (and a console 403).
    var RESOLVER = 'https://gpdycx7mqwspis65gnxrnwy3a40lmyzw.lambda-url.us-west-1.on.aws/public/template-resolve/';
    async function lookup(id) {
      if (!window.GIOPublicResource) throw error('TEMPLATE_TOOLS_UNAVAILABLE', 'The template loading tools are unavailable.');
      var response = await window.GIOPublicResource.read(RESOLVER + encodeURIComponent(id), { maximum: 2097152, timeoutMs: 12000 });
      if (!response.ok) throw error('TEMPLATE_RESOLVER_UNAVAILABLE', 'You can upload your photos without a template.');
      var value;
      try { value = JSON.parse(new TextDecoder().decode(response.bytes)); }
      catch (_) { throw error('TEMPLATE_RESOLVER_INVALID', 'You can upload your photos without a template.'); }
      if (!value || value.schema !== 'gio-template-resolution-v1' || value.id !== id) throw error('TEMPLATE_RESOLVER_INVALID', 'The template resolution needs review.');
      if (value.status !== 'found') {
        var codes = { missing: 'TEMPLATE_NOT_FOUND', ambiguous: 'TEMPLATE_ID_AMBIGUOUS', invalid: 'TEMPLATE_CONFIGURATION_INVALID', unavailable: 'TEMPLATE_RESOLVER_UNAVAILABLE' };
        throw error(codes[value.status] || 'TEMPLATE_RESOLVER_INVALID', 'You can upload your photos without a template.');
      }
      if (value.kind === 'photo') {
        var photoKey = window.GIOFileTemplateCore.templateKey(id);
        if (value.key !== photoKey) throw error('TEMPLATE_ID_MISMATCH', 'The template ID does not match its resource.');
        return { kind: 'photo', id: id, key: photoKey, file: window.GIOFileTemplateCore.validateTemplate(value.file, id) };
      }
      if (value.kind === 'multi-surface') {
        if (!window.GIOMultiSurfaceCore) throw error('TEMPLATE_TOOLS_UNAVAILABLE', 'The print-area tools are unavailable.');
        var multiKey = window.GIOMultiSurfaceCore.templateKey(id);
        if (value.key !== multiKey) throw error('TEMPLATE_ID_MISMATCH', 'The template ID does not match its resource.');
        return { kind: 'multi-surface', id: id, key: multiKey, file: window.GIOMultiSurfaceCore.normalizeTemplate(value.file, id) };
      }
      if (value.kind === 'composition') {
        var compositionKey = window.GIOLayeredCore.compositionKey(id);
        if (value.key !== compositionKey) throw error('TEMPLATE_ID_MISMATCH', 'The template ID does not match its resource.');
        var payload = window.GIOLayeredCore.validateEnvelope(value.envelope, 'composition');
        if (payload.id !== id) throw error('TEMPLATE_ID_MISMATCH', 'The template ID does not match its resource.');
        return { kind: 'composition', id: id, key: compositionKey, envelope: value.envelope };
      }
      throw error('TEMPLATE_RESOLVER_INVALID', 'The template type needs review.');
    }
    async function resolve(context) {
      var id = assignment(context).id;
      // Canonical key validation happens before any network request.
      if (!window.GIOFileTemplateCore || !window.GIOLayeredCore) throw error('TEMPLATE_TOOLS_UNAVAILABLE', 'The template tools are unavailable.');
      window.GIOFileTemplateCore.templateKey(id);
      if (cache[id]) return cache[id];
      if (pending[id]) return pending[id];
      pending[id] = (async function () {
        try {
          var selected = await lookup(id);
          cache[id] = selected; return selected;
        } finally { delete pending[id]; }
      }());
      return pending[id];
    }
    return { resolve: resolve };
  }
  window.GIOUnifiedTemplateRouter = { version: '2.15.1', assignment: assignment, create: create };
}(window));
